import { useMemo } from "react";
import { useIdentificationDocumentsQuery } from "web_myplann/Api/Client/useIdentificationDocumentsQuery";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import {
	getPaperworkDocumentDisplayName,
	sortIdentificationDocuments,
} from "web_myplann/Profile/Helpers/paperworkDocument";

export const usePaperworkDocuments = () => {
	const { t } = useResource();
	const {
		data,
		isLoading,
		isPending,
		isError,
		isSuccess,
		isRefetching,
		refetch,
	} = useIdentificationDocumentsQuery();

	const documents = useMemo(
		() =>
			sortIdentificationDocuments(data?.data ?? [], (document) =>
				getPaperworkDocumentDisplayName(
					document,
					t(Resources.Paperwork.Types[document.documentType]),
				),
			),
		[data, t],
	);

	return {
		documents,
		isLoading,
		isPending,
		isError,
		isSuccess,
		isRefetching,
		refetch,
	};
};
